// Generated by GitHub Copilot
import Insights from "../components/Insights";

/**
 * Render the dedicated Medium insights page.
 *
 * @param {{profile: Record<string, any>, loading?: boolean}} props Component props.
 * @returns {JSX.Element} Insights page section.
 */
function InsightsPage({ profile, loading = false }) {
    return (
        <Insights profile={profile} loading={loading} />
    );
}

export default InsightsPage;
